import type { ReactNode } from "react";

interface MetricTileProps {
  icon?: ReactNode;
  label: ReactNode;
  value: ReactNode;
  hint?: ReactNode;
  description?: ReactNode;
  className?: string;
  iconClassName?: string;
}

const containerClasses =
  "flex gap-3 rounded-2xl border border-slate-200 bg-slate-50/90 px-4 py-3 shadow-sm shadow-slate-200/60 transition-colors dark:border-slate-700 dark:bg-slate-800/70 dark:shadow-none";
const iconWrapperClasses =
  "flex h-10 w-10 items-center justify-center rounded-full bg-white text-slate-700 shadow dark:bg-slate-800 dark:text-slate-300 dark:shadow-none";
const labelClasses =
  "text-xs uppercase tracking-wide text-slate-500 dark:text-slate-400";
const valueClasses = "text-base font-semibold text-slate-900 dark:text-slate-100";
const hintClasses = "text-xs text-slate-500 dark:text-slate-400";

export function MetricTile({
  icon,
  label,
  value,
  hint,
  description,
  className,
  iconClassName,
}: MetricTileProps) {
  const detailText = description ?? hint;

  return (
    <div className={[containerClasses, className].filter(Boolean).join(" ")}>
      {icon ? (
        <span
          className={[iconWrapperClasses, iconClassName]
            .filter(Boolean)
            .join(" ")}
          aria-hidden
        >
          {icon}
        </span>
      ) : null}
      <div className="flex flex-col gap-0.5">
        <span className={labelClasses}>{label}</span>
        <strong className={valueClasses}>{value}</strong>
        {detailText ? <small className={hintClasses}>{detailText}</small> : null}
      </div>
    </div>
  );
}
